import styled, { css } from 'styled-components';

import { getPurpurBorder, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

export const BlockSection = styled.section`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    padding-top: ${getPurpurSpacing('400')};
    padding-bottom: ${getPurpurSpacing('400')};

    ${purpurMedia('md')`
        padding-top: ${getPurpurSpacing('600')};
        padding-bottom: ${getPurpurSpacing('600')};
    `};
`;

type HeaderProps = {
    $isReversed?: boolean;
};

export const BlockHeaderContainer = styled.div<HeaderProps>`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('100')};
    margin-bottom: ${getPurpurSpacing('300')};

    ${purpurMedia('md')`
        align-items: center;
        justify-content: space-between;
        margin-bottom: ${getPurpurSpacing('400')};
    `};

    ${({ $isReversed }) => purpurMedia('md')`
        flex-direction: ${$isReversed ? 'row-reverse' : 'row'};
    `};
`;

export const videoBaseStyles = css`
    width: 100%;
    aspect-ratio: 1.83;
    border-radius: ${getPurpurBorder('radiusLg')};
    object-fit: cover;
    display: block;
    overflow: hidden;

    ${purpurMedia('md')`
        aspect-ratio: 1.79;
    `};

    ${purpurMedia('lg')`
        aspect-ratio: 1.5;
    `};
`;
